// @ts-check

import Network from '../../../../infrastructure/js/modules/network';



/**
 * @param {{ externalId: string; }} data
 */
export function fetchLocationDetails(data) {
  
  let externalId = data.externalId;
  if (!externalId) {
    return;
  }
  
  
  let requestModel = {
    locationName: externalId
  };
  
  return Network.post(`livemap/location-details`, requestModel);
}


/**
 * @param {any} data
 */
export function fetchMapMenuItems(data) {
  return Network.get(`livemap/settings/menu-items`);
}

/**
 * @param {number | string} mapId
 */
export function fetchMapSetting(mapId) {
  return Network.get(`livemap/settings/${mapId}`);
}

export function fetchFullStatus() {
  return Network.post(`livemap/full-status`);
}


/**
 * @param {{ query: any; }} data
 */
export function searchMap(data) {
  
  let requestModel = {
    query: data.query
  };
  
  return Network.post(`livemap/search`, requestModel);
}



